import { render, staticRenderFns } from "./SelectPlanoContas.vue?vue&type=template&id=ccaaa2da&scoped=true"
import script from "./SelectPlanoContas.vue?vue&type=script&lang=js"
export * from "./SelectPlanoContas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaaa2da",
  null
  
)

export default component.exports